// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class EnrollmentStatusResponseModel {
    static getAttributeTypeMap() {
        return EnrollmentStatusResponseModel.attributeTypeMap;
    }
}
EnrollmentStatusResponseModel.discriminator = undefined;
EnrollmentStatusResponseModel.additionalProperties = false;
EnrollmentStatusResponseModel.attributeTypeMap = [
    {
        "name": "pharmacyMemberNumber",
        "baseName": "pharmacyMemberNumber",
        "type": "string"
    },
    {
        "name": "medicalMemberNumber",
        "baseName": "medicalMemberNumber",
        "type": "string"
    },
    {
        "name": "startDate",
        "baseName": "startDate",
        "type": "Date"
    },
    {
        "name": "endDate",
        "baseName": "endDate",
        "type": "Date"
    },
    {
        "name": "enrollmentStatus",
        "baseName": "enrollmentStatus",
        "type": "string"
    },
];
//# sourceMappingURL=enrollmentStatusResponseModel.js.map